import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { motion } from "framer-motion";
import ProductCard from "./ProductCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProductShowcase() {
    const { data, isLoading, isError } = useQuery({
        queryKey: ["products"],
        queryFn: () => axios.get(`${API}/products`).then((r) => r.data),
    });

    return (
        <section id="products" className="relative py-24 sm:py-28">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                    className="mb-14"
                >
                    <p className="text-xs font-mono-brand uppercase tracking-[0.3em] text-spidey-neon">
                        La collection — Drop 2026
                    </p>
                    <h2 className="mt-3 font-display uppercase text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
                        Deux paires. Une légende.
                    </h2>
                    <p className="mt-4 max-w-xl text-zinc-400">
                        Chaque paire est contrôlée avant expédition. Livraison offerte
                        dès 50 € — le duo la déclenche à lui tout seul, et t'économise 9,99 €.
                    </p>
                </motion.div>

                {isLoading && (
                    <div className="grid md:grid-cols-2 gap-8">
                        {[0, 1].map((i) => (
                            <div key={i} className="aspect-[3/4] bg-spidey-card border border-zinc-800/80 rounded-2xl animate-pulse" />
                        ))}
                    </div>
                )}

                {isError && (
                    <div className="rounded-2xl border border-zinc-800 bg-spidey-card p-10 text-center text-zinc-400">
                        Impossible de charger la collection. Recharge la page dans un instant.
                    </div>
                )}

                {data && (
                    <div className="grid md:grid-cols-2 gap-8 items-stretch">
                        {data.map((p, i) => (
                            <ProductCard key={p.slug} product={p} index={i} wide={p.slug === "spider-web-duo"} />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}
